import {
  linksForBoundaryDisplayName,
  resolveBoundarySchoolsDisplayName,
} from "@/shared/utils/resolve-boundary-schools-display-name";

import type { ShapeItem } from "./shape-item.types";
import type { IBoundaryPayload } from "../../map-panel-context";

export function resolveBoundaryPanelDisplayName(payload: IBoundaryPayload): string {
  return resolveBoundarySchoolsDisplayName(linksForBoundaryDisplayName(payload));
}

export function buildBoundaryStudentListSelectionShapes(
  payload: IBoundaryPayload,
): ShapeItem[] {
  const boundaryDisplayName = resolveBoundaryPanelDisplayName(payload);

  return [
    {
      id: payload.boundaryId ?? boundaryDisplayName,
      label: boundaryDisplayName,
      value: boundaryDisplayName,
      previewCoordinates: payload.previewCoordinates,
      previewColor: payload.color ?? undefined,
    },
  ];
}
